// eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-ignore
import * as React from 'react'
import './styles.css'
import InfoLine from './InfoLine'
import moment from 'moment'
import { CreateConsumerReservationRequestBody } from '@meniudigital/shared'

export default function ConfirmationModal(props: CreateConsumerReservationRequestBody) {
  const { requestedDateTime, numberOfPeople, phoneNumber, emailAddress, extraComments, fullName } = props

  const displayDate = moment(requestedDateTime).calendar(null, {
    sameDay: '[Azi], D MMMM [la] HH:mm',
    nextDay: '[Mâine], D MMMM [la] HH:mm',
    nextWeek: 'dddd, D MMMM [la] HH:mm',
    sameElse: 'dddd, D MMMM [la] HH:mm',
  })

  return (
    <>
      <div className="backdrop"></div>
      <div className="modal">
        <h1>Rezervare trimisă</h1>
        <p>
          Cererea ta de rezervare a fost trimisă. Vei primi un e-mail de confirmare imediat ce aceasta e acceptată de restaurant.
        </p>
        <div className="info-title">Detaliile rezervării</div>
        <div className="details-wrapper">
          <InfoLine label="Nume" value={fullName} imageName="user" />
          <InfoLine label="Număr de persoane" value={numberOfPeople.toString()} imageName="group" />
          <InfoLine label="Data și ora" value={displayDate} imageName="calendar" />
          <InfoLine label="Email-ul tău" value={emailAddress} imageName="envelope" />
          <InfoLine label="Numărul tău de telefon" value={phoneNumber} imageName="phone" />
          <InfoLine label="Mențiuni" value={extraComments} imageName="comment" />
        </div>
      </div>
    </>
  )
}
